import { getLocalDate, svgToDataURL } from 'common/utils';
import { intl } from 'i18n/Translations';

const ICON_HEIGHT = 94 * 2.5;

const SVG_HEIGHT = 94;
const CARD_HORIZONTAL_MARGIN = 11;
const CARD_WIDTH_OFFSET = 22;
const TITLE_TEXT_X = 19;
const TITLE_TEXT_RIGHT_PADDING = 19;
const MIN_CARD_WIDTH = 150;
const TITLE_TEXT_AVERAGE_CHAR_WIDTH = 4.5;
const TITLE_TEXT_PADDING = TITLE_TEXT_X + TITLE_TEXT_RIGHT_PADDING;

const getTitleLine = ({
  serviceTitle,
  totalPrice,
  currency,
  litersAmount
}: any) => `${serviceTitle}: ${totalPrice} ${currency} (${litersAmount} ${intl.formatMessage({ id: 'l.' })})`;

const getSvgWidth = (titleLine: string) => {
  const calculatedCardWidth = Math.ceil(titleLine.length * TITLE_TEXT_AVERAGE_CHAR_WIDTH + TITLE_TEXT_PADDING);
  const cardWidth = Math.max(calculatedCardWidth, MIN_CARD_WIDTH);

  return cardWidth + CARD_WIDTH_OFFSET;
};

const getIcon = ({
  stationCode,
  serviceTitle,
  totalPrice,
  currency,
  date,
  litersAmount,
  svgWidth
}: any) => (
  `
  <svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${SVG_HEIGHT}" viewBox="0 0 ${svgWidth} ${SVG_HEIGHT}" fill="none">
    <g clip-path="url(#clip0_2167_199)">

    <g filter="url(#filter0_ddd_2167_199)">
    <rect x="${CARD_HORIZONTAL_MARGIN}" y="8" width="${svgWidth - CARD_WIDTH_OFFSET}" height="70" rx="8" fill="white"/>
    <text fill="#30343B" style="white-space: pre" xml:space="preserve" font-family="Arial" font-size="11" font-weight="300" letter-spacing="0.004em"><tspan x="19" y="27.7598">${serviceTitle}: <tspan font-weight="500">${totalPrice} ${currency} (${litersAmount} ${intl.formatMessage({ id: 'l.' })})</tspan></tspan></text>
    <text fill="#515B69" style="white-space: pre" xml:space="preserve" font-family="Arial" font-size="10" letter-spacing="0.004em"><tspan x="19" y="42.418">${getLocalDate(date)}</tspan></text>
    <rect x="19" y="52" width="45" height="18" rx="4" fill="#9BA4B0" fill-opacity="0.14"/>
    <text fill="#515B69" style="white-space: pre" xml:space="preserve" font-family="Arial" font-size="11" font-weight="500" letter-spacing="0.01em"><tspan x="25" y="64.7598">${stationCode}</tspan></text>
    <path d="M106.5 78L78.5 78L79.7065 78C82.2863 78 84.7511 79.0348 86.5155 80.8587L90.7977 85.2853C91.7196 86.2382 93.2804 86.2382 94.2023 85.2853L98.4845 80.8587C100.249 79.0348 102.714 78 105.293 78L106.5 78Z" fill="white"/>
    </g>
    </g>
    <defs>
    <filter id="filter0_ddd_2167_199" x="-5" y="-5" width="${svgWidth + 10}" height="112" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="5"/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.04 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2167_199"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="3"/>
    <feGaussianBlur stdDeviation="8"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="effect1_dropShadow_2167_199" result="effect2_dropShadow_2167_199"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="9"/>
    <feGaussianBlur stdDeviation="6"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.12 0"/>
    <feBlend mode="normal" in2="effect2_dropShadow_2167_199" result="effect3_dropShadow_2167_199"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_2167_199" result="shape"/>
    </filter>
    <clipPath id="clip0_2167_199">
    <rect width="${svgWidth}" height="${SVG_HEIGHT}" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  `
);

export const getClientEventTitleIcon = ({
  stationCode,
  serviceTitle,
  totalPrice,
  currency,
  date,
  litersAmount
}: any) => {
  const titleLine = getTitleLine({ serviceTitle, totalPrice, currency, litersAmount });
  const svgWidth = getSvgWidth(titleLine);

  return {
    url: svgToDataURL(
      getIcon({
        stationCode,
        serviceTitle,
        totalPrice,
        currency,
        date,
        litersAmount,
        svgWidth: svgWidth
      })
    ),
    width: svgWidth * 2.5,
    height: ICON_HEIGHT
  };
};
